import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import Card from '../common/Card/Card'; // Наша базовая карточка
import styles from './FormListItem.module.css';
import { FiFileText, FiChevronRight } from 'react-icons/fi'; // Иконки

const FormListItem = ({ form }) => {
    const intl = useIntl();

    const statusText = form.status
        ? intl.formatMessage({ id: `form.status.${form.status}`, defaultMessage: form.status })
        : '';

    // Генерируем ссылку на страницу настроек формы (создадим ее позже)
    // Используем ID формы, так как slug может быть изменен
    const settingsLink = `/form/${form.id}/settings`;

    return (
        <Link to={settingsLink} className={styles.linkWrapper}>
            <Card className={`${styles.formCard} ${form.status !== 1 ? styles.inactive : ''}`}>
                <FiFileText className={styles.icon} />
                <div className={styles.info}>
                    <h3 className={styles.title}>{form.title}</h3>
                    <p className={styles.description}>
                        <FormattedMessage
                            id="form.submissionsCount"
                            defaultMessage="{count, plural, one {# submission} other {# submissions}}"
                            values={{ count: form.submissions_count || 0 }}
                        />
                    </p>
                </div>
                <div className={styles.statusWrapper}>
                    {/*{statusText && <span className={`${styles.statusBadge} ${styles[form.status === 1 ? 'published' : 'draft']}`}>{statusText}</span>}                    <FiChevronRight className={styles.chevron} />*/}
                </div>
            </Card>
        </Link>
    );
};

export default FormListItem;
